module.exports = __webpack_public_path__ + "static/content-05-dbc2f2faf2684f97b6463649a4de8922.jpg";